var __jsx = React.createElement;
import React from 'react';
import useIsMobile from '@hooks/useIsMobile';
import { useTranslation } from "@i18n";
import { useLang } from "@/common/Contexts/LanguageContext";
import desktopStep1 from '../icons/desktop-step1.png';
import desktopStep2 from '../icons/desktop-step2.png';
import desktopStep3 from '../icons/desktop-step3.png';
import desktopStep4 from '../icons/desktop-step4.png';
import mobileStep1Ar from '../icons/mobile-step1-ar.png';
import mobileStep2Ar from '../icons/mobile-step2-ar.png';
import mobileStep3Ar from '../icons/mobile-step3-ar.png';
import mobileStep4Ar from '../icons/mobile-step4-ar.png.png';
import mobileStep1En from '../icons/mobile-step1-en.png';
import mobileStep2En from '../icons/mobile-step2-en.png';
import mobileStep3En from '../icons/mobile-step3-en.png';
import mobileStep4En from '../icons/mobile-step4-en.png';
var DESKTOP_IMAGES = [desktopStep1, desktopStep2, desktopStep3, desktopStep4];
var MOBILE_IMAGES = {
  ar: [mobileStep1Ar, mobileStep2Ar, mobileStep3Ar, mobileStep4Ar],
  en: [mobileStep1En, mobileStep2En, mobileStep3En, mobileStep4En]
};
var STEP_TITLE_KEYS = ['steps/step_1_title', 'steps/step_2_title', 'steps/step_3_title', 'steps/step_4_title'];
var SellCarSteps = function SellCarSteps(_ref) {
  var data = _ref.data,
    id = _ref.id;
  var isMobile = useIsMobile();
  var lang = useLang();
  var _useTranslation = useTranslation(['sell_trade_landing']),
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement("div", {
    id: id !== null && id !== void 0 ? id : "sell-car-steps-section",
    className: "pb-8 md:py-20 px-4"
  }, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-steps-container",
    className: "max-w-[1200px] mx-auto"
  }, /*#__PURE__*/React.createElement("h2", {
    id: "sell-car-steps-title",
    className: "text-primary-new text-[20px] font-bold leading-[32px] md:text-[32px] text-center mb-8 md:mb-12"
  }, data.title), /*#__PURE__*/React.createElement("div", {
    id: "sell-car-steps-grid",
    className: "flex flex-col md:grid md:grid-cols-2 gap-6 md:gap-10"
  }, data.payloads.map(function (step, index) {
    var _MOBILE_IMAGES$lang;
    var stepImage = isMobile ? ((_MOBILE_IMAGES$lang = MOBILE_IMAGES[lang]) !== null && _MOBILE_IMAGES$lang !== void 0 ? _MOBILE_IMAGES$lang : MOBILE_IMAGES.ar)[index] : DESKTOP_IMAGES[index];
    var titleKey = STEP_TITLE_KEYS[index];
    // odd index → text on right half, even index → text on left half
    var isLeft = index % 2 === 0;
    return /*#__PURE__*/React.createElement("div", {
      id: "sell-car-step-".concat(index),
      key: step.id,
      className: "relative w-full"
    }, /*#__PURE__*/React.createElement("img", {
      id: "sell-car-step-image-".concat(index),
      loading: "lazy",
      src: stepImage,
      alt: titleKey ? tShort(titleKey, {
        ns: 'sell_trade_landing'
      }) : step.title,
      className: "w-full h-auto object-contain"
    }), titleKey && /*#__PURE__*/React.createElement("h3", {
      id: "sell-car-step-title-".concat(index),
      className: [
      // Mobile: half-width, alternating left/right
      'absolute top-[40%] w-[48%]',
      // Desktop: full-width centered, upper area of image
      'md:w-full md:inset-x-0 md:top-[25%]', 'px-2 md:px-[7rem]', 'text-white font-bold leading-tight', 'text-[24px] md:text-[48px]', 'text-center pointer-events-none',
      // Mobile only: alternating position (md:inset-x-0 overrides on desktop)
      lang === "ar" ? isLeft ? 'left-4' : 'right-8' : !isLeft ? 'left-4' : 'right-8'].join(' ')
    }, tShort(titleKey, {
      ns: 'sell_trade_landing'
    })));
  }))));
};
export default SellCarSteps;